import type { Polygon } from "leaflet";
import type { GenericObject } from "../general";
import type { RegionRef } from "./regionRef.model";
import type { LocationRef } from "./locationRef.model";
import type { TrackSeqRef } from "../..";

export interface RegionMap extends GenericObject{
    date: Date;
    regions: RegionRef[];
    locations: LocationRef[];
    tracks: TrackSeqRef[];

    isChecked: boolean;
    isIndeterminate: boolean;
    color: string;
    polygonLayer: Polygon;

    description?: string;
    searchKeys?: string;
}

export const COMMON = {
    opacity: 0.2,
    fillOpacity: 0.5,
    dashArray: null
};

export const COMMONTRACK = {
    opacity: 0.8,
    fillOpacity: 0.7,
    dashArray: null
};

export const DIMMED = {
    opacity: 1,
    fillOpacity: 0,
    dashArray: '10 10'
};